import type { HTMLAttributes } from 'react';

type Props = HTMLAttributes<HTMLSpanElement> & { as?: 'span' | 'div' | 'b' | 'td' };

/** Numeric data (Jost with tabular figures, so digits line up in columns). */
export function Mono({ as: Tag = 'span', className, ...rest }: Props) {
  return <Tag className={className ? `u-mono ${className}` : 'u-mono'} {...rest} />;
}
